import "../../stylesheets/PopupRegister.css";
import React, { useState } from "react";
import PopupConfirmDeactivateUser from "./PopupConfirmDeactivateUser.js";

function PopupDeactivateUser(props) {
  const [finished, setFinished] = useState(false);

  const deactivateUser = async () => {
    props.setDeactivateUser(props.id);

    let result = await fetch(
      process.env.REACT_APP_API_BASE_URL + "/admin/disableUser/" + props.id,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    result = await result.json();

    if (result.status == 200) {
      setFinished(true);
    } else {
      alert("Error al eliminar usuario");
    }
  };

  return (
    <>
      <div className="popup-register-container popup-deactivate-user">
        <div className="popup">
          <div className="lightgreen">
            <button
              className="btn-close-popup"
              onClick={() => props.setDeactivateUser(-1)}
            >
              X
            </button>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/stage_characters/Popup_Imagen.png"
              }
              alt=""
            />
          </div>
          <h1>¿Eliminar usuario?</h1>
          <h2>Esta acción no se puede revertir</h2>
          <button className="btn lightgreen-btn" onClick={deactivateUser}>
            Confirmar
          </button>
        </div>
      </div>

      {finished ? (
        <PopupConfirmDeactivateUser
          setDeactivateUser={props.setDeactivateUser}
          setRefresh={props.setRefresh}
          setFinished={setFinished}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default PopupDeactivateUser;
